export class PlanUsuario {
	public idPlanSf: string;
	public idPlanUsuario: string;
	public idContratacion: string;
	public usuarioId: string;
	public emisorId: string;
	public nombrePlan: string;
	public fechaContratacion: Date;
	public fechaCorte: Date;
	public pagado: boolean;
	public totalPagado?: number;
	public activo: boolean;

	public diasDiferencia: number;
	public formaPago: string;
	public fechaCaducidad: Date;
	public nombreEmpresa: string;
	public mesDte: string;
	public anioDte: number;
	public maxDte: number;
	public currentDte: number;
	public maxBhe: number;
	public currentBhe: number;
	public pagoMensual: number;
	public adicionales: number;
	public valorAdicionalUf: number;
	public valorAdicionalPesos: number;
	public isDemo: boolean;

	public cantidadFacturas: number;

	public totalDineroDte: number;
	public totalDineroBhe: number;
	public currentUsuarios: number;
	public maxUsuarios: number;

	public additionalDte: number;
	public additionalBhe: number;
	public totalExtra: number;

	public rutEmpresa: string;
	public correoEmpresa: string;
	public rutRepresentanteLegal: string;
	public giroEmpresa: string;
	public nombreCompleto: string;
	public clientes: number;
	public proveedores: number;
	public dtes_recibidos: number;

	public logoEmpresa: string;

	public meses: number;
	public neto: number;
	public subTotal: number;
	public iva: number;
	public descuento: number;
	public total: number;
	public totalCertificacion: number;
	public totalPlanes: number;
}
